import React from 'react'
import { Mail, Eye } from "lucide-react"

const EmailLogs = () => {
    return (
        <div className='px-xl-5 px-lg-4 px-3 py-3 page-body'>
            <div className='row'>
                <div className='col-12'>
                    <div className="email-logs-cont">
                        <div class="d-flex flex-column">
                            <h5 class="fs-4 fw-semibold m-0">Email Logs</h5>
                            <span class="text-muted fs-6">A log of all automated emails sent by the system.</span>
                        </div>

                        <div className='email-logs-table-cont mt-4'>
                            <div className="table-responsive">
                                <table className='table table-hover m-0 border-top'>
                                    <thead>
                                        <tr>
                                            <td>Recipient</td>
                                            <td>Subject</td>
                                            <td>Type</td>
                                            <td>Sent At</td>
                                            <td>Actions</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr className='align-middle'>
                                            <td>
                                                <div className='d-flex align-items-center gap-2'>
                                                    <Mail stroke='#71717a' />
                                                    <span className='text-muted'>admin@example.com</span>
                                                </div>
                                            </td>
                                            <td>Daily Attendance Report</td>
                                            <td><span className='log-pills'>admin_report</span></td>
                                            <td>November 9th, 2025 4:40 PM</td>
                                            <td>
                                                <button type="button" className='btn email-logs-preview-btn gap-1' data-bs-toggle="modal" data-bs-target="#previewModal">
                                                    <Eye />
                                                    Preview
                                                </button>
                                            </td>
                                        </tr>
                                        <tr className='align-middle'>
                                            <td>
                                                <div className='d-flex align-items-center gap-2'>
                                                    <Mail stroke='#71717a' />
                                                    <span className='text-muted'>manager@example.com</span>
                                                </div>
                                            </td>
                                            <td>Late Arrival Notice: John Doe</td>
                                            <td><span className='log-pills'>late_notice</span></td>
                                            <td>November 9th, 2025 3:40 PM</td>
                                            <td>
                                                <button type='button' className='btn email-logs-preview-btn gap-1' data-bs-toggle="modal" data-bs-target="#previewModal">
                                                    <Eye />
                                                    Preview
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade email-logs-modal" id="previewModal" tabindex="-1" aria-labelledby="previewModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal-lg">
                    <div class="modal-content px-2 pt-2">
                        <div className='d-flex align-items-center justify-content-between py-2 px-3'>
                            <h4 className='m-0'>Email Preview</h4>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <div className=''>
                                <h6><strong>To:</strong> admin@example.com</h6>
                                <h6><strong>Subject:</strong> Daily Attendance Report</h6>
                                <span><strong>Date:</strong> November 9th, 2025 4:40 PM</span>
                            </div>
                            <div className='email-logs-inner-modal mt-2'>
                                <h6 className='fs-4 fw-semibold'>Daily Report</h6>
                                <span>All employees were present.</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default EmailLogs